import {
    BrowserRouter as Router,
    Routes,
    Route,
    Navigate,
} from 'react-router-dom'
import LoginPage from '../pages/LoginPage'
import Home from '../pages/Home'
import CreateInstancePage from '../pages/client/CreateInstance'

import RegionCreatePage from '../pages/admin/RegionCreatePage'
import CreateVolumePage from '../pages/client/CreateVolume'
import RequireAuth from '../components/RequireAuth'
import CreateImageForm from '../pages/client/CreateImage'
import CreateKeypairForm from '../pages/client/CreateKeyPair'
import AdminDashboard from '../pages/admin/AdminDashBoard'
import MyInstancesPage from '../pages/client/InstancesPage'
import VolumeListPage from '../pages/client/VolumeListPage'
import KeypairListPage from '../pages/client/KeypairListPage'
import ClientDashBoard from '../pages/client/ClientDashBoard'
import UserManagementPage from '../pages/admin/UserManagePage'
import VPSDetailPage from '../pages/client/VpsDetail'
import SnapshotListPage from '../pages/client/SnapshotListPage'
import VolumeSnapshotListPage from '../pages/client/VolumeBackupList'
import BillingDashBoard from '../pages/client/BillingDashboard'
import SupportPage from '../pages/client/SupportPage'
import ForgotPasswordPage from '../pages/client/ForgotPassPage'
import RegisterPage from '../pages/RegisterPage'
import TwoFactorSetupPage from '../pages/client/TwoFactorSetupPage'
import EditProfilePage from './../pages/client/EditProfilePage'
import CreateUserPage from '../pages/admin/CreateUserPage'
import AdminUserDetailPage from '../pages/admin/UserDetailPage'
import ImageListPage from '../pages/admin/ImageListPage'
import NetworkListPage from '../pages/client/Network'
import { CreateNetworkPage } from '../pages/client/CreateNetworkPage'
import FloatingIPListPage from '../pages/client/FloatingIPPage'
import InstancesPage from '../pages/admin/InstancesPage'
import CreateProjectTypePage from '../pages/admin/CreateProjectType'
import ProjectListPage from '../pages/admin/ProjectListPage'
import CreateProjectPage from '../pages/admin/CreateProjectPage'
import ProjectDetail from '../pages/admin/ProjectDetailsPage'
import ProjectDashboard from '../pages/client/manageProject/ManagePackage'
import NetworkDashboardPage from './../pages/admin/network/NetworkDashboard'
import SubnetManagement from './../pages/admin/network/SubnetManagement'
import NetworkDetailPage from './../pages/admin/network/NetworkDetail'
import TCreateNetworkPage from './../pages/admin/network/CreateNetworkPage'
import ImageCreatePage from '../pages/admin/ImageCreatePage'
import CreateInstanceAsAdminPage from '../pages/admin/CreateInstancePage'
import InfrastructureManager from '../pages/admin/InfrastructureManager'
import RequireAdmin from '../components/RequireAdmin'
import PlanIndexPage from '../pages/admin/plan/IndexPage'
import ClusterListPage from '../pages/admin/ClusterListPage'
import PlanCategoryManager from '../pages/admin/PlanCategoriesPage'
import AdminRegionsPage from '../pages/admin/AdminRegionsPage'
import ComputeTypeManager from '../pages/admin/ComputeTypesPage'
import PlanManager from '../pages/admin/PlanPage'
import SidebarLayout from '../components/admin/Siderbar'

function AppRoutes() {
    return (
        <Router>
            <Routes>
                {/* Public routes */}
                <Route path="/" element={<Home />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/register" element={<RegisterPage />} />
                <Route
                    path="/forgot-password"
                    element={<ForgotPasswordPage />}
                />
                {/* Protected routes */}
                <Route element={<RequireAuth />}>
                    <Route path="/profile" element={<EditProfilePage />} />
                    <Route path="/dashboard" element={<ClientDashBoard />} />
                    <Route path="/billing" element={<BillingDashBoard />} />
                    <Route
                        path="/create-instance"
                        element={<CreateInstancePage />}
                    />
                    <Route path="/instances" element={<MyInstancesPage />} />
                    <Route path="/client/vps/:id" element={<VPSDetailPage />} />
                    <Route path="/support" element={<SupportPage />} />
                    <Route path="/volumes" element={<VolumeListPage />} />
                    <Route path="/keypairs" element={<KeypairListPage />} />
                    <Route
                        path="/create-volume"
                        element={<CreateVolumePage />}
                    />
                    <Route path="/networks" element={<NetworkListPage />} />
                    <Route
                        path="/floating-ips"
                        element={<FloatingIPListPage />}
                    />

                    <Route
                        path="/create-network"
                        element={<CreateNetworkPage />}
                    />
                    <Route
                        path="/create-keypair"
                        element={<CreateKeypairForm />}
                    />
                    <Route path="/vps-backup" element={<SnapshotListPage />} />
                    <Route
                        path="/volume-backup"
                        element={<VolumeSnapshotListPage />}
                    />
                    <Route path="/setup-2fa" element={<TwoFactorSetupPage />} />
                    <Route
                        path="/manage-project"
                        element={<ProjectDashboard />}
                    />
                </Route>

                {/* Admin routes */}
                <Route element={<RequireAdmin />}>
                    <Route path="/admin" element={<SidebarLayout />}>
                        <Route
                            index
                            element={<Navigate to="dashboard" replace />}
                        />

                        <Route path="dashboard" element={<AdminDashboard />} />
                        <Route
                            path="create-user"
                            element={<CreateUserPage />}
                        />
                        <Route
                            path="users/:id"
                            element={<AdminUserDetailPage />}
                        />
                        <Route
                            path="users-manager"
                            element={<UserManagementPage />}
                        />
                        <Route path="images" element={<ImageListPage />} />
                        <Route path="instances" element={<InstancesPage />} />
                        <Route
                            path="create-package"
                            element={<CreateProjectTypePage />}
                        />
                        <Route
                            path="create-instance"
                            element={<CreateInstanceAsAdminPage />}
                        />
                        <Route
                            path="project-detail/:id"
                            element={<ProjectDetail />}
                        />
                        <Route path="projects" element={<ProjectListPage />} />
                        <Route
                            path="create-project"
                            element={<CreateProjectPage />}
                        />
                        <Route
                            path="network"
                            element={<NetworkDashboardPage />}
                        />
						<Route
                            path="images/create"
                            element={<ImageCreatePage />}
                        />
                    
                        <Route path="subnet" element={<SubnetManagement />} />
                        <Route
                            path="network-detail"
                            element={<NetworkDetailPage />}
                        />
                        <Route
                            path="create-networks"
                            element={<TCreateNetworkPage />}
                        />
                        <Route
                            path="regions/create"
                            element={<RegionCreatePage />}
                        />
                        <Route
                            path="infrastructure-manager"
                            element={<InfrastructureManager />}
                        />
                        <Route path="regions" element={<AdminRegionsPage />} />
                        <Route
                            path="clusters"
                            element={<ClusterListPage />}
                        />
                        <Route
                            path="compute-types"
                            element={<ComputeTypeManager />}
                        />
                        <Route
                            path="plan-categories"
                            element={<PlanCategoryManager />}
                        />
                        <Route path="plans" element={<PlanManager />} />
                    </Route>
                </Route>
            </Routes>
        </Router>
    )
}

export default AppRoutes
